import {
  determineDefaultColorScaleThreshold,
  useQuantitativeDataSummaryStats,
} from 'features/dataLayers'
import * as React from 'react'
import type { GeckoComponentDataFrame } from 'types'

/**
 * The default color scale threshold for a CDF, derived from its summary
 * statistics. This is the value a viz window renders with when no explicit
 * threshold override is provided.
 */
export function useDefaultColorThreshold(
  cdf: GeckoComponentDataFrame | undefined
) {
  const stats = useQuantitativeDataSummaryStats(cdf)
  return React.useMemo(
    () =>
      determineDefaultColorScaleThreshold(
        cdf?.data.params.view,
        cdf?.data.params.measurement_unit,
        stats.data
      ),
    [cdf, stats.data]
  )
}
